export default __webpack_public_path__ + "static/banner-mobile-4ad2ff05a3bc0a4cc60aa0d3569aaeb7.svg";